import type { RouteLocationRaw } from 'vue-router'

import type { ArticleDoc } from '@/types/content'
import type { PageKeyword } from '@/types/plan'

/** The query key that names the keyword selected in the page workbench. */
export const KEYWORD_QUERY = 'keyword'

/** The route of a page's workbench, with `keywordId` selected when given. */
export function pageRoute(pageId: string, keywordId?: string): RouteLocationRaw {
  return {
    name: 'page',
    params: { id: pageId },
    ...(keywordId ? { query: { [KEYWORD_QUERY]: keywordId } } : {}),
  }
}

/** The route of the page an article post was written for; `null` when no article carries that post. */
export function articlePageRoute(
  postId: string,
  articles: readonly Pick<ArticleDoc, 'postId' | 'pageId'>[],
): RouteLocationRaw | null {
  const article = articles.find((entry) => entry.postId === postId)
  return article ? pageRoute(article.pageId) : null
}

/** The route of the page a keyword serves, with the keyword selected; `null` for an unknown keyword. */
export function keywordPageRoute(
  keywordId: string,
  keywords: readonly Pick<PageKeyword, 'id' | 'pageId'>[],
): RouteLocationRaw | null {
  const keyword = keywords.find((entry) => entry.id === keywordId)
  return keyword ? pageRoute(keyword.pageId, keyword.id) : null
}
